import React, { FC } from 'react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContentProps,
  Icon,
} from '@kontentino/ui';
import { stopPropagation } from 'utils/mouseEvent';
import { FileSource } from 'app/components/fileSourceInput/types/fileSource';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons/faCirclePlus';
import clsx from 'clsx';

type Props = {
  fileSources: [FileSource, ...FileSource[]];
  disabled?: boolean;
  classNames?: {
    button?: string;
  };
  dropzoneContentProps?: DropdownMenuContentProps;
  triggerButton?: React.ReactNode;
};

const FileSourcePlusButtonPicker: FC<Props> = (props) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger disabled={props.disabled}>
        {props.triggerButton ?? (
          <Button
            data-name="file-source_plus-button"
            variant="tertiary"
            disabled={props.disabled}
            className={clsx('tw-group', props.classNames?.button)}
          >
            <Icon
              icon={faCirclePlus}
              className='tw-rounded-full tw-bg-white tw-text-primary-100 group-hover:tw-bg-primary-100 group-hover:tw-text-white group-data-[state="open"]:tw-bg-primary-100 group-data-[state="open"]:tw-text-white'
              withoutBoundary
              size="lg"
            />
          </Button>
        )}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        className="tw-z-10 tw-border tw-border-grayscale-30"
        {...props.dropzoneContentProps}
      >
        {props.fileSources.map((fileSource, index) => (
          <DropdownMenu.Item
            key={`file-source-${index}`}
            onSelect={fileSource.onClick}
            onClick={stopPropagation()}
            data-name={`file-source_option-${fileSource.attributes?.dataName}`}
            data-cy={`file-source_option-${fileSource.attributes?.dataCy}`}
          >
            {fileSource.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default FileSourcePlusButtonPicker;
